import { defineComponent, inject, ref, computed, watch, toRefs } from '@vue/composition-api';
import { AsyncGogoRouteView, loadGogoLib } from './runtime-loader';
import RuntimeReport from '@/reporter/RuntimeReport';
import { useStore } from '@/store';
import { TYPE, PAGE_TYPE } from '@/loaders/page/consts';
import { useGogoCssReset } from './css-reset-counter';
import { getAppParams } from '@/utils/getAppParams';
import { useGogoWatermark } from '@components/watermark/useGogoWatermark';
export default defineComponent({
    name: 'GogoRuntimeRouterView',
    components: {
        AsyncGogoRouteView,
    },
    props: {
        projectId: {
            type: String,
            required: true,
        },
        pageId: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const { pageId } = toRefs(props);
        const gogoRef = ref(null);
        const store = useStore();
        const gogoHost = inject('gogoHostRef');
        loadGogoLib('runtime'); // 触发加载 lib - 虽然好像没啥必要但是也搞一下吧
        useGogoCssReset();
        const project = computed(() => store.state.runtime.project);
        const page = ref({});
        const getPageDetail = async (pageId) => await store.dispatch('runtime/getPageDetail', {
            projectId: props.projectId,
            pageId,
            env: getAppParams('env'),
            branch: getAppParams('branch'),
        });
        const { rendererGogoWatermark } = useGogoWatermark();
        watch(() => pageId.value, async (newPageId, oldPageId) => {
            if (!newPageId || newPageId === oldPageId)
                return;
            page.value = await getPageDetail(newPageId);
            rendererGogoWatermark({
                id: 'wuji-pagelet-watermark',
                container: gogoRef.value,
                project: project.value,
                page: page.value,
            });
        }, { immediate: true });
        return {
            gogoRef,
            gogoHost,
            project,
        };
    },
    data() {
        return {
            reporter: null,
        };
    },
    watch: {
        pageId: {
            handler(newPageId, oldPageId) {
                const { project, reporter } = this;
                // 上报pv和pgOut
                const { projectId, env } = window.RUNTIME_CONFIGS;
                if (oldPageId && reporter) {
                    reporter.pgOut()?.destroy();
                    this.reporter = null;
                }
                this.reporter = new RuntimeReport({
                    projectInfo: {
                        projectId,
                        projectName: project?.name,
                        parentId: project?.parentId,
                    },
                    pageId: newPageId,
                    envId: env,
                    pageInfo: {
                        type: TYPE.AI,
                        pageType: PAGE_TYPE.CONTENT,
                        contentType: 'normal',
                    },
                    reportDimensions: [],
                    agentReport: project?.advanceConfig?.agentReport ?? false,
                });
                this.reporter.pv();
            },
            immediate: true,
        },
    },
});
